import { FC, useEffect, useState } from "react";
import Image from "next/image";

import { List, Tabs, TabsProps } from "antd";
import styles from "./antd.module.scss";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css";
import { cn } from "@/lib/utils";
import ArrowSvg from "@/public/icon/arrow";
import {
  productList,
  productInfo,
  productMenuList,
} from "../config/productInfo";
import Link from "next/link";
interface SectionProps {
  isMobile: boolean;
}

interface InfoListItem {
  title: string;
  icon: string;
  desc: string;
  href: string;
}
const SwiperList: FC<{
  infoList: InfoListItem[];
  className: string;
}> = ({ infoList, className }) => {
  return (
    <div className={className}>
      <Swiper
        modules={[Navigation]}
        className={cn("swiper mySwiper")}
        slidesPerView={4}
        spaceBetween={20}
        loop={false}
        navigation={{
          nextEl: ".swiper-button-next.section3",
          prevEl: ".swiper-button-prev.section3",
        }}
      >
        <div className="swiper-wrapper">
          {infoList.map((item, idx) => (
            <SwiperSlide key={idx} className="bg-transparent flex-center !flex">
              <div
                key={idx}
                className="bg-transparent w-full relative pt-16 flex flex-col flex-shrink-0"
              >
                {/*  <div className="w-full bg-[#f5f7fa] h-14 mb-24"></div> */}
                <Image
                  className="w-32 h-32 absolute right-0 top-0"
                  src={item.icon}
                  alt={item.title}
                  width="160"
                  height="160"
                  quality={100}
                />
                <div
                  className={cn(
                    "bg-white rounded-lg pt-20 pb-10 px-10 h-80 flex-col flex justify-between text-[#333333]",
                    "hover:bg-[#004EA2] hover:text-white group transition-all  duration-500 ease-in-out"
                  )}
                >
                  <div className="flex-col flex gap-y-4">
                    <h5 className="text-lg font-medium">{item.title}</h5>
                    <p className="text-sm  overflow-hidden text-ellipsis line-clamp-3">
                      {item.desc}
                    </p>
                  </div>
                  <p className="text-sm cursor-pointer underline  transition-all duration-500  ease-in-out">
                    <Link
                      className="text-[#666666] group-hover:text-white"
                      href={item.href}
                    >
                      查看详情
                    </Link>
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
      <div className="swiper-button-next section3 translate-y-6 after:!content-[''] !right-[-50px]">
        <ArrowSvg fill="#004DA1" color="#004DA1" className="w-6 h-6" />
      </div>
      <div className="swiper-button-prev section3 translate-y-6 after:!content-[''] !left-[-50px]">
        <ArrowSvg
          fill="#004DA1"
          color="#004DA1"
          className="w-6 h-6 rotate-180"
        />
      </div>
    </div>
  );
};
const CardList: FC<{
  infoList: InfoListItem[];
  className: string;
}> = ({ infoList, className }) => {
  const [initLoading, setInitLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInitLoading(false);
    /* 
      setData(res.results);
      setList(res.results); 
    */
  }, []);
  const handleLoadMore = () => {
    setLoading(true);
    /* 
      setData(res.results);
      setList(res.results); 
    */
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  return (
    <List
      grid={{ column: 2, gutter: 16 }}
      dataSource={infoList}
      loading={initLoading}
      className={className}
      /* loadMore={
        !initLoading && !loading ? (
          <div
            style={{
              textAlign: "center",
              marginTop: 4,
            }}
            className="text-[#004EA2]"
          >
            <p className="cursor-pointer" onClick={handleLoadMore}>
              查看更多
            </p>
          </div>
        ) : null
      } */
      renderItem={(item, idx) => (
        <List.Item
          className="bg-white !pb-6 !px-4 !pt-0 flex-col items-center !flex rounded-lg"
          key={idx}
        >
          <Image
            className="w-20 h-20"
            src={item.icon}
            alt={item.title}
            width="160"
            height="160"
            quality={100}
          />
          <div className="flex flex-1 flex-col items-start space-y-3 w-full">
            <h5 className="text-sm font-medium whitespace-nowrap">
              {item.title}
            </h5>
            <p className="text-xs overflow-hidden text-ellipsis line-clamp-2 min-h-[2rem]">
              {item.desc}
            </p>
            <p className="text-xs cursor-pointer underline">
              <Link className="text-[#004EA2]" href={item.href}>
                查看详情
              </Link>
            </p>
          </div>
        </List.Item>
      )}
    />
  );
};

const productLists = [
  { key: "safe", label: "安全", infoList: productList["safe"] },
  { key: "network", label: "网络", infoList: productList["network"] },
  { key: "5g", label: "5G", infoList: productList["5g"] },
];

const items: TabsProps["items"] = productLists.map((item) => ({
  key: item.key,
  label: item.label,
  children: (
    <>
      <CardList infoList={item.infoList} className="!block md:!hidden" />
      <SwiperList infoList={item.infoList} className="!hidden md:!block" />
    </>
  ),
}));

export const Section3: FC<SectionProps> = () => {
  return (
    <>
      <div className="container pt-10 md:pt-24">
        <h3 className="text-[#333333] text-center  text-lg md:text-3xl mb-0">
          网络与信息安全领域的产品
        </h3>
        <h5 className="text-[#999999] text-base my-5 text-center hidden md:block">
          以零信任技术为基础，围绕5G、全连接、安全接入、SASE、安全服务运营等方向提供专业产品及解决方案
        </h5>
      </div>
      <Tabs
        defaultActiveKey="1"
        items={items}
        centered
        className={cn(styles.tabBox)}
      />
    </>
  );
};
